import React, { useState } from "react";
import styled from "@emotion/styled";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { stringAvatar } from "../../utils/helpers";
import dayjs from "dayjs";
import TextRenderer from "../TextEditor/TextRenderer";




const Container = styled("div")(({ theme }) => ({
  padding: "1rem 2rem",
}));

const SectionTitle = styled("div")(({ theme }) => ({
  fontSize: "14px",
  // fontWeight: "600",
  marginBottom: "1rem",
  color: theme.palette.text.secondary,
  [theme.breakpoints.down("xl")]: {
    fontSize: "18px",
  },
}));


const ScriptsTab = ({ scripts = [] }) => {
  return (
    <Container>

      {scripts.length === 0 ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="200px"
          color="#939090"
        >
          <Typography>No scripts found for this task.</Typography>
        </Box>
      ) : (
        scripts.map((item) => (
          <Box key={item.id} display="flex" gap="8px" mt={2}>
            <Avatar {...stringAvatar(item?.posted_by?.name)} />

            <Box
              flex={1}
              border="1px solid #E5E5E5"
              borderRadius="8px"
              padding="8px"
            >
              {/* HEADER */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box display="flex" gap="8px" alignItems="center">
                  <Typography fontWeight={600} fontSize="14px">
                    {item?.posted_by?.name || "User"}
                  </Typography>
                  <Typography fontSize="13px" color="#939090">
                    {dayjs(item?.created_at).format("DD-MMM-YYYY")}
                  </Typography>
                </Box>
              </Box>

              {/* BODY */}
              <Box mt={1}>
                <TextRenderer html={item.text} view="render" padding="0px" />
              </Box>
            </Box>
          </Box>
        ))
      )}
    </Container>
  );
};


export default ScriptsTab;
